/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
 */
export interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'accountType': GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'companyName': string | null;
}

export const GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum = typeof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum[keyof typeof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum];


